<script>
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import moment from "moment";
import Drawer from "@/components/drawer";
import Multiselect from "vue-multiselect";

// Custom Components
import GuestService from "@/helpers/APIService/guest.service";
import BookingService from "@/helpers/APIService/booking.service";
import Folio from "@/components/BookingDetails/Folio.vue";
import AccountService from "@/helpers/APIService/account.service";

import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import {
  when_booking_additional_charge,
  when_booking,
  cancellation_fee_within,
} from "@/helpers/global.variable";
import hotelService from "@/helpers/APIService/hotel.service";

export default {
  components: {
    Drawer,
    Folio,
    Multiselect,
  },
  props: {
    currentProps: Object,
  },
  data() {
    return {
      isFolioShow: false,
      payments: [],
      when: when_booking_additional_charge,
      when_booking,
      cancellation_fee_within,
      paymentMethods: [],
      openAdditionalChargeModel: false,
      additionalCharge: {
        amount: 0.0,
        description: "",
        charge_type: "",
        errorMessage: "",
        submitted: false,
        createError: false,
      },
      isBtnLoading: false,
      add_new_card: false,
      cardNumber: "",
      cardExpiry: "",
      cardCvv: "",
      cardHolder: "",
      cardErrors: {},
      cardErrorMessage: "",
      isError: false,
      is_btn_loading: false,
      cardList: [],
      paymentSchedule: [],
      capture: false,
      capture_min: 0,
      capture_max: 0,
      refund_min: 0,
      refund_max: 0,
      tempPaymentId: "",
      tempPaymentStatus: "",
      tempPaymentAmount: "",
      capture_amount: 0,
      refund_amount: 0,
      captureAmountMsg: "",
      refundAmountMsg: "",
      accommodation: 0,
      extras: 0,
      sd: 0,
      paid: 0,
      due: 0,
      total: 0,
      comment: "",
      payment_id: "",
      payment_status: "",
      payment_status_text: "",
      commentError: true,
      commentMsg: "",
      is_data_loading: true,
      credit_card: "",
      temp_payment_account_id: "",
      temp_payment_child_account_id: "",
      payment_account_list: [],
      payment_child_account_list: [],
      payment_account: "",
      payment_child_account: "",
      primaryGuestAsCardHolderName: "",
      total_charges: 0,
      total_payment: 0,
      current_bal: 0,
      total_sd: 0,
      is_card_loading: false,
      folioCheckbox: [],
      SdFolioCheckbox: [],
      select_payment_type: "charge_now",
      paymentScheduleDropdown: "",
      transaction_type: "",
      card_type: "online",
      kiosk: "",
      getKioskPolicyList: [],
      SDArray: [],
      sd_charges: {
        authorize_amount: 0.0,
        received_amount: 0.0,
        release_amount: 0.0,
        total_sd: 0.0,
        total_selected_charges: 0.0,
        error_msg: "",
      },
      total_selected_charges: 0.0,
      charge_type_list: [],
      cancellationPolicy: null,
    };
  },
  computed: {
    ...authComputed,
    detailProps() {
      return {
        booking: this.currentProps.booking,
      };
    },
  },
  onMounted() {
    this.$refs.cardNumInput.focus();
  },
  watch: {
    // handle auto-focus to next field
    cardNumber: function (val) {
      if (this.$cardFormat.validateCardNumber(val)) {
        this.$refs.cardExpInput.focus();
      }
    },
    cardExpiry: function (val) {
      if (this.$cardFormat.validateCardExpiry(val)) {
        this.$refs.cardCvcInput.focus();
      }
    },
  },
  async mounted() {
    this.getPaymentAccount();
    this.paymentType();
    this.getKioskPolicyDropdownList();
    this.chargeType();
    this.$root.$on("new_charge_added", (data) => {
      if (data == true) {
        let count = 0;
        count = count + 1;
        if (count == 1) {
          this.getBookingWisePayments();
        }
      }
    });
    this.getBookingWisePayments();
    this.getPaymentPlicyRules();
  },
  validations: {
    additionalCharge: {
      amount: { required },
      description: { required },
      charge_type: { required },
    },
  },
  methods: {
    //Payment account data get method
    getPaymentAccount() {
      AccountService.getPaymentAccount()
        .then((response) => {
          response.map((item) => {
            if (item.name != "Macrotech") {
              this.payment_account_list.push({
                value: item.id,
                text: item.name,
                disabled: false,
              });
            }
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    getKioskPolicyDropdownList() {
      UserService.getKioskPolicyDropdownList()
        .then((response) => {
          response.map((item) => {
            this.getKioskPolicyList.push({
              value: item.id,
              text: item.kiosk_machine_number,
              disabled: false,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    //Get payment account child account method
    getPaymentChildAccount(payment_account_id) {
      this.payment_child_account = "";
      AccountService.getPaymentChildAccount(payment_account_id)
        .then((response) => {
          this.payment_child_account_list = [];
          response.map((item) => {
            this.payment_child_account_list.push({
              value: item.id,
              text: item.name,
              disabled: false,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    getPaymentChildAccountDrop(payment_account_id, type) {
      let account_id = "";
      if (type == "single") {
        account_id = payment_account_id;
      } else {
        account_id = payment_account_id.value;
      }
      this.payment_child_account = "";
      AccountService.getPaymentChildAccount(account_id)
        .then((response) => {
          this.payment_child_account_list = [];
          response.map((item) => {
            this.payment_child_account_list.push({
              value: item.id,
              text: item.name,
              disabled: false,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get payment policy rule for cancelletion policy
    getPaymentPlicyRules() {
      if (
        !(
          this.currentProps.booking &&
          this.currentProps.booking.booking_source &&
          this.currentProps.booking.booking_source.id
        )
      ) {
        return;
      }
      hotelService
        .getBookingSourcePaymentRule(
          this.currentProps.booking.booking_source.id
        )
        .then((response) => {
          this.cancellationPolicy = response.cancellation_policy;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    //Update payment method
    handleSubmit() {
      this.additionalCharge.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          booking: this.currentProps.booking.id,
          description: this.additionalCharge.description,
          charge_type: this.additionalCharge.charge_type,
          debit: parseFloat(this.additionalCharge.amount).toFixed(2),
        };
        this.isBtnLoading = true;
        BookingService.addAdditionalCharge(this.currentProps.booking.id, data)
          .then(() => {
            this.getBookingWisePayments();
            Middleware.notification(
              "Successfully added additional charge !!",
              "success",
              3000
            );
            this.resetModal();
            this.isBtnLoading = false;
          })
          .catch((err) => {
            errorHandler(err);
            if (err.response.status === 403) {
              this.additionalCharge.createError = true;
              this.additionalCharge.errorMessage = "Something wrong in card.";
            } else {
              this.additionalCharge.createError = true;
              this.additionalCharge.errorMessage = err.response.data;
            }
            this.isBtnLoading = false;
          });
      }
    },
    //Validate add new card method
    validate() {
      this.cardErrors = {};
      // Validate card holder name
      if (this.cardHolder === null || "") {
        this.cardErrors.cardHolder = "Please Add Card Holder Name.";
      }
      // validate card number
      if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
        this.cardErrors.cardNumber = "Invalid Credit Card Number.";
      }

      // validate card expiry
      if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
        this.cardErrors.cardExpiry = "Invalid Expiration Date.";
      }

      // validate card CVC
      if (!this.$cardFormat.validateCardCVC(this.cardCvv)) {
        this.cardErrors.cardCvv = "Invalid CVV.";
      }
      if (Object.keys(this.cardErrors).length !== 0) {
        return false;
      } else {
        return true;
      }
    },
    addNewCard() {
      this.is_btn_loading = true;
      const validation = this.validate();
      if (validation) {
        const expiryDate = this.cardExpiry.split("/");
        let year = expiryDate[1].trim();
        let month = expiryDate[0].trim();
        UserService.getStripePaymentGatewayDetails()
          .then((payment_gateway) => {
            if (!payment_gateway.is_active) {
              return (this.cardErrorMessage = "Payment gateway is not active");
            }
            const data = {
              guest: this.currentProps.booking.primary_guest,
              card_holder_name: this.cardHolder,
              card_number: this.cardNumber,
              exp_month: month,
              exp_year: year,
              cvv: this.cardCvv,
              is_default: true,
              payment_gateway_type: "macrotech",
            };

            if (this.card_type == "online") {
              GuestService.addCard(
                this.currentProps.booking.primary_guest,
                data
              )
                .then(async (response) => {
                  await this.$emit("updateDetails");
                  Middleware.notification(
                    "Successfully added !!",
                    "success",
                    3000
                  );

                  this.cardList.push(response);
                  this.$root.$emit("addNewCard", response);
                  this.resetPaymentModal();
                  // this.getPaymentCardList();
                  this.paymentMethods.push({
                    value: response.id,
                    text: `${this.cardHolder} ****${response.last_digit} -${response.card_type}`,
                    disabled: false,
                  });
                  this.is_btn_loading = false;
                })
                .catch((err) => {
                  errorHandler(err);
                  this.is_btn_loading = false;
                  this.isError = true;
                  this.cardErrorMessage = err.response.data.message;
                });
            }
          })
          .catch((error) => {
            this.is_btn_loading = false;
            errorHandler(error);
          });
      }
    },
    emvCardAdd() {
      this.is_btn_loading = true;
      let emvData = new FormData();
      emvData.append("kiosk", this.kiosk);
      emvData.append("guest", this.currentProps.booking.primary_guest.id);

      GuestService.addEmvCard(
        this.currentProps.booking.primary_guest.id,
        emvData
      )
        .then(async (response) => {
          await this.$emit("updateDetails");
          Middleware.notification("Successfully added !!", "success", 3000);

          this.cardList.push(response);
          this.resetPaymentModal();
          // this.getPaymentCardList();
          this.paymentMethods.push({
            value: response.id,
            text: `${this.cardHolder} ****${response.last_digit} - ${response.card_type}`,
            disabled: false,
          });
          this.is_btn_loading = false;
        })
        .catch((err) => {
          errorHandler(err);
          this.is_btn_loading = false;

          this.isError = true;
          this.cardErrorMessage =
            "Error Code : " +
            err.response.data.gateway_response.gateway_error_code +
            "<br>" +
            "Error Message : " +
            err.response.data.gateway_response.gateway_error_message;
        });
    },
    //Payment schedules method
    getBookingWisePayments() {
      this.paymentSchedule = [];
      this.total_payment = 0.0;
      this.total_charges = 0.0;
      this.total = 0.0;
      this.total_sd = 0.0;
      BookingService.getBookingWisePayments(this.currentProps.booking.id)
        .then((response) => {
          response.map((item) => {
            let temp = {};
            let action_option = {};
            let color = "warning";
            let text_class = "text-";
            let border_class = "border-";
            var icon = "fas fa-clock";
            var payment_status = "";
            let payment_schedule = "";

            if (item.status == "pending") {
              color = "warning";
              if (item.transaction_type == "charge") {
                action_option = {
                  charge_now: "Charge Now",
                  authorized: "Authorize Now",
                  mark_as_paid: "Mark as Paid",
                  manually_voided: "Manually Void",
                };
                payment_schedule =
                  "Due On " + moment(item.payment_schedule).format("D MMM");
              }
              if (item.transaction_type == "deposit") {
                action_option = {
                  authorized: "Authorize Now",
                  manually_voided: "Manually Void",
                  mark_as_paid: "Mark as Paid",
                };
                payment_schedule =
                  "Due On " + moment(item.payment_schedule).format("D MMM");
              }
              icon = "fas fa-clock";
              payment_status = "Pending";
            } else if (item.status == "waiting_for_approval") {
              color = "warning";
              if (item.transaction_type == "charge") {
                action_option = {
                  mark_as_paid: "Mark as Paid",
                  manually_voided: "Manually Void",
                  send_mail_link: "Resend Email Link",
                  copy_auth_link: "Copy Authentication Link(URL)",
                };
                icon = "fas fa-clock";
                payment_schedule =
                  "Due On " + moment(item.payment_schedule).format("D MMM");
                payment_status = "On arrival";
              } else {
                action_option = {
                  manually_voided: "Manually Void",
                  send_mail_link: "Resend Email Link",
                  copy_auth_link: "Copy Authentication Link(URL)",
                };
                icon = "fas fa-clock";
                payment_schedule =
                  "Due On " + moment(item.payment_schedule).format("D MMM");
                payment_status = "On arrival";
              }
            } else if (item.status == "waiting_for_kiosk") {
              color = "warning";
              action_option = {
                charge_now: "Charge Now",
                authorized: "Authorize Now",
                mark_as_paid: "Mark as Paid",
                manually_voided: "Manually Void",
              };
              payment_schedule =
                "Due On " + moment(item.payment_schedule).format("D MMM");
              icon = "fas fa-clock";
              payment_status = "On arrival";
            } else if (item.status == "authorized") {
              color = "success";
              if (item.transaction_type == "deposit") {
                if (item.debit > item.amount_received) {
                  action_option = {
                    capture: "Use To Pay",
                    released: "Release",
                  };
                }
                payment_schedule =
                  "Due On " + moment(item.payment_schedule).format("D MMM");
              }
              if (item.transaction_type == "charge") {
                action_option = {
                  capture: "Capture Now",
                  release: "Release",
                };
                if (
                  item.payment_schedule != null &&
                  item.payment_schedule != ""
                ) {
                  payment_schedule =
                    "Due On " + moment(item.payment_schedule).format("D MMM");
                }
              }

              payment_schedule = moment(item.payment_schedule).format(
                "D MMM, h:mm a"
              );
              icon = "fas fa-lock";
              if (item.credit_card != null && item.credit_card != "") {
                payment_status = "Authorized";
              } else {
                payment_status = "Paid";
              }
            } else if (item.status == "partial_refund") {
              color = "warning";
              action_option = {
                refunded: "Refund",
              };
              payment_schedule =
                // "Refund On " + moment(item.updated_at).format("D MMM, h:mm a");
                moment(item.updated_at).format("D MMM, h:mm a");
              icon = "fas fa-clock";
              payment_status = "Partial Refund";
            } else if (item.status == "full_refund") {
              color = "warning";
              action_option = {};
              icon = "fas fa-clock";
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
              payment_status = "Full Refund";
            } else if (item.status == "paid") {
              color = "success";
              action_option = {
                refunded: "Refund",
              };
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
              icon = "fas fa-check-circle";
              payment_status = "Paid";
            } else if (item.status == "refunded") {
              color = "info";
              icon = "fas fa-reply";
              payment_status = "Refunded";
            } else if (item.status == "released") {
              color = "success";
              icon = "fas fa-sort-amount-up   ";
              payment_status = "Released";
            } else if (item.status == "overdue") {
              color = "dark";
              if (item.transaction_type == "deposit") {
                action_option = {
                  authorized: "Authorize Now",
                  manually_voided: "Manually Void",
                  mark_as_paid: "Mark as Paid",
                };
              }
              if (item.transaction_type == "charge") {
                action_option = {
                  charge_now: "Charge Now",
                  authorized: "Authorize Now",
                  mark_as_paid: "Mark as Paid",
                  manually_voided: "Manually Void",
                };
              }
              payment_schedule =
                "Due On " + moment(item.payment_schedule).format("D MMM");
              icon = "fas fa-check-circle";
              payment_status = "Overdue";
            } else if (item.status == "voided") {
              color = "secondary";
              icon = "fas fa-ban";
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
              payment_status = "Voided";
            } else if (item.status == "manually_voided") {
              color = "secondary";
              icon = "fas fa-ban";
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
              payment_status = "Manually Voided";
            } else if (item.status == "capture") {
              color = "info";
              icon = "fas fa-money-check";
              payment_status = "Captured";
              if (item.debit > item.amount_received) {
                action_option = {
                  capture: "Capture Now",
                  refunded: "Refund",
                };
              } else {
                action_option = {
                  refunded: "Refund",
                };
              }
            } else if (item.status == "capture_failed") {
              color = "danger";
              action_option = {
                capture: "Capture Now",
                release: "Release",
              };
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
              icon = "fas fa-exclamation-triangle";
              payment_status = "Capture Failed";
            } else if (item.status == "paused") {
              color = "danger";
              icon = "fas fa-pause-circle";
              payment_status = "Paused";
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
            } else if (item.status == "mark_as_paid") {
              color = "success";
              icon = "fas fa-check-circle";
              action_option = {
                refunded: "Refund",
              };
              payment_schedule = moment(item.payment_schedule).format(
                "D MMM, h:mm a"
              );
              payment_status = "Paid";
            } else if (item.status == "declined") {
              color = "danger";
              action_option = {
                charge_now: "Re-charge Now",
                authorized: "Re-authorize Now",
                manually_voided: "Manually Void",
                mark_as_paid: "Mark as Paid",
              };
              icon = "fas fa-exclamation-triangle";
              payment_status = "Declined";
              payment_schedule = moment(item.updated_at).format(
                "D MMM, h:mm a"
              );
            }

            if (item.credit_card != null && item.credit_card != "") {
              this.credit_card = item.credit_card;
            }
            // payment_schedule
            temp = {
              payment_method: item.credit_card,
              payment_schedule: payment_schedule,
              payment_status: payment_status,
              payment_type: item.transaction_type,
              payment_account_id: item.payment_account,
              payment_method_id: item.payment_method,
              payment_currency: item.currency,
              amount: item.debit,
              amount_authorized: item.amount_authorized,
              amount_received: item.amount_received,
              amount_refunded: item.amount_refunded,
              amount_released: item.amount_released,
              description: item.description,
              last_payment_error_code: item.last_payment_error_code,
              last_payment_error_message: item.last_payment_error_message,
              options: action_option,
              bg_class: "bg-" + color,
              text_class: text_class + color,
              border_class: border_class + color,
              icon: icon,
              id: item.id,
            };
            this.paymentSchedule.push(temp);
            this.current_bal =
              parseFloat(this.total_charges) - parseFloat(this.total_payment);
            this.is_data_loading = false;
          });

          this.cardList = [];
          let card_holder_name_from_guestList = "";
          // this.currentProps.booking.guest.map((item) => {
          //   card_holder_name_from_guestList =
          //     item.first_name + " " + item.last_name;
          //   this.cardHolder = item.first_name + " " + item.last_name;
          //   item.credit_card.map((card) => {
          //     if (item.id == this.currentProps.booking.primary_guest) {
          //       card_holder_name_from_guestList =
          //         item.first_name + " " + item.last_name;
          //       this.primaryGuestAsCardHolderName =
          //         item.first_name + " " + item.last_name;
          //     }
          //     card_holder_name_from_guestList =
          //       item.first_name + " " + item.last_name;
          //     this.cardList.push(card);
          //   });
          // });

          this.paymentMethods = [];
          // this.currentProps.booking.guest.map((item) => {
          //   item.credit_card.map((card) => {
          //     this.paymentMethods.push({
          //       value: card.id,
          //       text: `${
          //         card.card_holder_name === null
          //           ? card_holder_name_from_guestList
          //           : card.card_holder_name
          //       } ****${card.last_digit} - ${card.card_type}`,
          //       disabled: false,
          //     });
          //     this.cardHolder =
          //       card.card_holder_name !== null
          //         ? card.card_holder_name
          //         : card_holder_name_from_guestList;
          //   });
          // });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    paymentStatusChange(
      payment_id,
      payment_action_type,
      booking_payment_amount,
      received_amount,
      authorize_amount,
      refund_amount,
      released_amount,
      payment_method_id,
      payment_account_id,
      credit_card,
      transaction_type
    ) {
      switch (payment_action_type) {
        case "charge_now":
          if (this.paymentMethods.length == 0) {
            Swal.fire({
              title: "Credit Card Required",
              text: "Add at least one credit card.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#238dfa",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Add",
            }).then((result) => {
              if (result.value) {
                this.$refs.submitBtn.click();

                // this.add_new_card = true;
              }
            });
            return;
          }
          if (
            this.currentProps.booking.default_credit_card == null ||
            this.currentProps.booking.default_credit_card == ""
          ) {
            Swal.fire({
              title: "Credit Card Required",
              text: "Select credit card.",
              icon: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000,
            });
            return;
          }
          this.credit_card = this.currentProps.booking.default_credit_card;
          this.payment_id = payment_id;
          this.transaction_type = transaction_type;
          this.payment_status = "charge_now";
          this.payment_status_text = "Charge Now";
          this.$refs["charge-modal"].show();

          break;

        case "change_amount":
          break;

        case "mark_as_paid":
          this.payment_id = payment_id;
          this.transaction_type = transaction_type;
          this.payment_status = "mark_as_paid";
          this.payment_status_text = "Mark As Paid";
          this.total_selected_charges = 0.0;
          this.$refs["comment-modal"].show();

          break;

        case "manually_voided":
          this.payment_id = payment_id;
          this.transaction_type = transaction_type;
          this.payment_status = "manually_voided";
          this.payment_status_text = "Manually Voided";
          this.bookingPaymentAuthNow();
          break;

        case "voided":
          this.bookingPaymentCancelModal(
            payment_id,
            payment_action_type,
            "void"
          );
          break;

        case "authorized":
          if (this.paymentMethods.length == 0) {
            Swal.fire({
              title: "Credit Card Required",
              text: "Add at least one credit card.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#238dfa",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Add",
            }).then((result) => {
              if (result.value) {
                this.$refs.submitBtn.click();
              }
            });
            return;
          }
          if (
            this.currentProps.booking.default_credit_card == null ||
            this.currentProps.booking.default_credit_card == ""
          ) {
            Swal.fire({
              title: "Credit Card Required",
              text: "Select credit card.",
              icon: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000,
            });
            return;
          }
          this.credit_card = this.currentProps.booking.default_credit_card;
          this.payment_id = payment_id;
          this.transaction_type = transaction_type;
          this.payment_status = "authorized";
          this.payment_status_text = "Authorize Now";
          this.total_selected_charges = 0.0;
          this.$refs["authorized-modal"].show();
          break;

        case "send_mail_link":
          break;

        case "copy_auth_link":
          break;

        case "capture":
          if (transaction_type == "deposit") {
            this.payment_id = payment_id;
            this.transaction_type = transaction_type;
            this.payment_status = "capture";
            this.sd_charges.authorize_amount = authorize_amount;
            this.sd_charges.received_amount = received_amount;
            this.sd_charges.released_amount = released_amount;
            this.sd_charges.total_sd =
              parseFloat(authorize_amount) - parseFloat(received_amount);
            this.sd_charges.total_sd = this.sd_charges.total_sd.toFixed(2);
            this.sd_charges.total_selected_charges = 0.0;
            this.error_msg = "";
            this.paymentType();
            this.$refs["use-top-pay-modal"].show();
          } else {
            this.payment_id = payment_id;
            this.transaction_type = transaction_type;
            this.payment_status = "capture";
            this.payment_status_text = "Capture Now";
            this.bookingPaymentAuthNow();
          }
          break;

        case "released":
          this.payment_id = payment_id;
          this.transaction_type = transaction_type;
          this.payment_status = "released";
          this.payment_status_text = "Released";
          this.bookingPaymentAuthNow();
          break;

        case "refunded":
          this.payment_id = payment_id;
          this.transaction_type = transaction_type;
          this.payment_status = "refunded";
          this.payment_status_text = "Refunded";
          this.payment_child_account = "";
          if (credit_card == null || credit_card == "") {
            this.payment_account = payment_method_id.id;
            this.getPaymentChildAccount(payment_method_id.id);
            this.payment_child_account = payment_account_id.id;
          }
          // this.bookingPaymentRefund();

          this.refund_max = received_amount;
          this.refund_min = refund_amount;
          this.refund_amount =
            parseFloat(this.refund_max) - parseFloat(this.refund_min);
          this.refund_amount = this.refund_amount.toFixed(2);
          this.tempPaymentId = payment_id;
          this.tempPaymentAmount = received_amount;
          this.$refs["refund-modal"].show();
          break;

        default:
          return;
      }
    },
    //Capture payment method
    bookingPaymentChargeNow() {
      this.is_btn_loading = true;
      // payment_status
      this.folioCheckbox.push(this.tempPaymentId);
      let paymentStatusData = {
        booking: this.currentProps.booking.id,
        folio_transaction: this.folioCheckbox,
        status: "charge_now",
        gateway_transaction_method: "online",
        credit_card: this.credit_card,
      };
      UserService.bookingPaymentChargeNow(
        this.currentProps.booking.id,
        paymentStatusData
      )
        .then((response) => {
          if (
            response.last_payment_error_message != null &&
            response.last_payment_error_message != ""
          ) {
            Swal.fire({
              title: "Opp's !",
              text: response.last_payment_error_message,
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#238dfa",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Ok",
            });
          }

          this.getBookingWisePayments();
          this.is_btn_loading = false;
          this.comment = "";
          this.$refs["charge-modal"].hide();
          this.resetPaymentListModal();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Get payment status mark as paid
    bookingSDPayment() {
      let paymentStatusData = new FormData();
      if (this.payment_status == "authorized") {
        //
      } else if (this.payment_status == "mark_as_paid") {
        paymentStatusData.append("status", "authorized");
        paymentStatusData.append("payment_method", this.credit_card);
        paymentStatusData.append("payment_account", "authorized");
        paymentStatusData.append("comment", this.credit_card);
        paymentStatusData.append("gateway_transaction_method", "online");
      }

      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm to " + this.payment_status_text + ".",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.value) {
          // payment_status

          this.is_btn_loading = true;

          paymentStatusData.append(
            "payment_account",
            this.payment_child_account.value
          );
          paymentStatusData.append("remark_note", this.comment);

          BookingService.bookingSDPayment(
            this.currentProps.booking.id,
            this.payment_id,
            paymentStatusData
          )
            .then((response) => {
              this.getBookingWisePayments();
              this.$refs["use-top-pay-modal"].hide();
              this.is_btn_loading = false;
              this.comment = "";
            })
            .catch((error) => {
              errorHandler(error);
            });
          this.is_btn_loading = false;
          this.resetPaymentListModal();
        }
      });
    },
    // Capture payment in method
    capturePayment() {
      this.captureValCheck();
      this.is_btn_loading = true;
      let paymentCaptureData = new FormData();
      paymentCaptureData.append("capture_amount", this.capture_amount);
      paymentCaptureData.append("status", "capture");
      paymentCaptureData.append("remark_note", this.comment);
      paymentCaptureData.append("gateway_transaction_method", "online");
      BookingService.bookingPaymentCaptureAmount(
        this.currentProps.booking.id,
        this.tempPaymentId,
        paymentCaptureData
      )
        .then((response) => {
          this.is_btn_loading = false;
          if (
            response.last_payment_error_message != null &&
            response.last_payment_error_message != ""
          ) {
            Swal.fire({
              title: "Opp's !",
              text: response.last_payment_error_message,
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#238dfa",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Ok",
            });
          }
          this.getBookingWisePayments();
          this.$refs["capture-modal"].hide();
          this.resetPaymentListModal();
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Capture value from payment in method
    captureValCheck() {
      let capture_amt =
        parseFloat(this.capture_max) - parseFloat(this.capture_min);
      if (
        this.capture_amount > parseFloat(capture_amt) ||
        this.capture_amount <= 0
      ) {
        this.isError = true;
        this.captureAmountMsg = "Please Enter Valid Amount";
        this.capture_amount = capture_amt.toFixed(2);
        return;
      } else {
        this.isError = false;
        this.captureAmountMsg = "";
      }
    },
    // Refund payment method
    refundValCheck() {
      let refund_amt =
        parseFloat(this.refund_max) - parseFloat(this.refund_min);
      if (
        this.refund_amount > parseFloat(refund_amt) ||
        this.refund_amount <= 0
      ) {
        this.isError = true;
        this.refundAmountMsg = "Please Enter Valid Amount";
        this.refund_amount = refund_amt.toFixed(2);
        return;
      } else {
        this.isError = false;
        this.refundAmountMsg = "";
      }
    },
    // Booking payment cancel modal
    bookingPaymentCancelModal(payment_id, payment_status, text) {
      this.payment_id = payment_id;
      this.payment_status = payment_status;
      this.payment_status_text = text;
      this.$refs["comment-modal"].show();
    },
    // Booking payment refund method
    bookingPaymentRefund() {
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm to Refund",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.value) {
          // payment_status

          let paymentStatusData = new FormData();
          paymentStatusData.append("status", "refund");
          paymentStatusData.append("gateway_transaction_method", "online");

          paymentStatusData.append(
            "refund_amount",
            parseFloat(this.refund_amount)
          );

          if (this.payment_account != null) {
            paymentStatusData.append("payment_method", this.payment_account);
            paymentStatusData.append(
              "payment_account",
              this.payment_child_account
            );
            paymentStatusData.append("gateway_transaction_method", "online");
          }
          BookingService.bookingPaymentReleaseAmount(
            this.currentProps.booking.id,
            this.payment_id,
            paymentStatusData
          )
            .then((response) => {
              this.getBookingWisePayments();
              this.$refs["refund-modal"].hide();
              this.is_btn_loading = false;
              this.comment = "";
            })
            .catch((error) => {
              errorHandler(error);
            });
          this.resetPaymentListModal();
        }
      });
    },
    //  Maintained different amount in payment method
    getDiffAmount(auth, received, refund, released, payment_type) {
      let string = "<ul>";
      if (payment_type == "charge" || payment_type == "payment") {
        string += "<li><span>Received:&nbsp $" + received + "</span></li>";
        string += "<li><span>Refunded:&nbsp $" + refund + "</span></li>";
      } else {
        string += "<li><span>Authorized:&nbsp $" + auth + "</span></li>";
        string += "<li><span>Received:&nbsp $" + received + "</span></li>";
        string += "<li><span>Refunded:&nbsp $" + refund + "</span></li>";
        string += "<li><span>Released:&nbsp $" + released + "</span></li>";
      }
      string += "</ul>";
      return {
        html: true,
        content: () => {
          return string;
        },
      };
    },
    // Final balance maintained in payment
    findBalance(total, received) {
      let balance = 0.0;
      balance = parseFloat(total) - parseFloat(received);
      return balance.toFixed(2);
    },
    // Reset payment list modal
    resetPaymentListModal() {
      this.capture_min = 0.0;
      this.capture_max = 0.0;
      this.refund_min = 0.0;
      this.refund_max = 0.0;
      this.tempPaymentId = "";
      this.tempPaymentStatus = "";
      this.tempPaymentAmount = "";
      this.capture_amount = 0.0;
      this.refund_amount = 0.0;
      this.captureAmountMsg = "";
      this.refundAmountMsg = "";
      this.comment = "";
      this.payment_id = "";
      this.payment_status = "";
      this.payment_status_text = "";
      this.commentError = true;
      this.commentMsg = "";
      this.credit_card = "";
      this.temp_payment_account_id = "";
      this.temp_payment_child_account_id = "";
      this.payment_child_account_list = [];
      this.payment_account = "";
      this.payment_child_account = "";
      this.folioCheckbox = [];
      this.paymentScheduleDropdown = "";
      this.select_payment_type = "charge_now";
    },
    resetModal() {
      this.is_btn_loading = false;
      this.additionalCharge = {
        amount: 0.0,
        description: "",
        when: "OAK",
        paymentMethod: "",
        errorMessage: "",
        submitted: false,
        createError: false,
      };
      this.openAdditionalChargeModel = !this.openAdditionalChargeModel;
    },
    //Reset payment modal
    resetPaymentModal() {
      this.add_new_card = !this.add_new_card;
      this.cardExpiry = "";
      this.cardCvv = "";
      this.cardErrors = {};
      this.cardErrorMessage = "";
      this.is_btn_loading = false;
      this.isError = false;
    },
    // Get list of payment card list method
    getPaymentCardList() {
      this.cardList = [];
      // this.currentProps.booking.guest.map((item) => {
      //   item.credit_card.map((card) => {
      //     this.cardList.push(card);
      //   });
      // });
    },
    // Change default payment method
    defaultPaymentMethod(cardId) {
      this.is_card_loading = true;
      let paymentData = new FormData();
      paymentData.append("default_credit_card", cardId);
      BookingService.updateBooking(this.currentProps.booking.id, paymentData)
        .then(async () => {
          this.cardList = [];
          await this.$emit("updateDetails");
          this.getPaymentCardList();
          this.is_card_loading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Authorize booking payment method
    bookingPaymentAuthNow() {
      this.is_btn_loading = true;
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm to " + this.payment_status_text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
      })
        .then((result) => {
          if (result.value) {
            this.folioCheckbox.push(this.payment_id);
            let paymentStatusData = {};
            let paymentStatusDataArr = new FormData();
            if (this.payment_status == "authorized") {
              if (this.transaction_type == "deposit") {
                paymentStatusDataArr.append("status", "authorized");
                paymentStatusDataArr.append("credit_card", this.credit_card);
                paymentStatusDataArr.append(
                  "gateway_transaction_method",
                  "online"
                );
              } else {
                paymentStatusData = {
                  booking: this.currentProps.booking.id,
                  folio_transaction: this.folioCheckbox,
                  status: "authorized",
                  credit_card: this.credit_card,
                  gateway_transaction_method: "online",
                };
              }
            } else if (this.payment_status == "capture") {
              paymentStatusData = {
                booking: this.currentProps.booking.id,
                folio_transaction: this.folioCheckbox,
                status: "capture",
                gateway_transaction_method: "online",
              };
            } else if (this.payment_status == "manually_voided") {
              paymentStatusData = {
                booking: this.currentProps.booking.id,
                folio_transaction: this.folioCheckbox,
                status: "manually_voided",
                gateway_transaction_method: "online",
              };
            } else if (this.payment_status == "released") {
              if (this.transaction_type == "deposit") {
                paymentStatusDataArr.append("status", "released");
                paymentStatusDataArr.append(
                  "gateway_transaction_method",
                  "online"
                );
              } else {
                paymentStatusData = {
                  booking: this.currentProps.booking.id,
                  folio_transaction: this.folioCheckbox,
                  status: "released",
                  gateway_transaction_method: "online",
                };
              }
            } else if (this.payment_status == "refunded") {
              if (this.transaction_type == "deposit") {
                paymentStatusDataArr.append("status", "refunded");
                paymentStatusDataArr.append(
                  "gateway_transaction_method",
                  "online"
                );
              } else {
                if (this.payment_account.value != null) {
                  paymentStatusData = {
                    booking: this.currentProps.booking.id,
                    refund_amount: parseFloat(this.refund_amount),
                    folio_transaction: this.folioCheckbox,
                    payment_account: this.payment_child_account.value,
                    payment_method: this.payment_account.value,
                    status: "refund",
                    gateway_transaction_method: "online",
                  };
                } else {
                  paymentStatusData = {
                    booking: this.currentProps.booking.id,
                    refund_amount: parseFloat(this.refund_amount),
                    folio_transaction: this.folioCheckbox,
                    status: "refund",
                    gateway_transaction_method: "online",
                  };
                }
              }
            } else if (this.payment_status == "mark_as_paid") {
              if (this.transaction_type == "deposit") {
                paymentStatusDataArr.append("status", "mark_as_paid");
                paymentStatusDataArr.append(
                  "payment_method",
                  this.payment_account.value
                );
                paymentStatusDataArr.append(
                  "payment_account",
                  this.payment_child_account.value
                );
                paymentStatusDataArr.append("comment", this.comment);
                paymentStatusDataArr.append(
                  "gateway_transaction_method",
                  "online"
                );
              } else {
                paymentStatusData = {
                  booking: this.currentProps.booking.id,
                  folio_transaction: this.folioCheckbox,
                  status: "mark_as_paid",
                  payment_method: this.payment_account.value,
                  payment_account: this.payment_child_account.value,
                  gateway_transaction_method: "online",
                };
              }
            } else if (this.payment_status == "charge_now") {
              this.folioCheckbox.push(this.payment_id);
              paymentStatusData = {
                booking: this.currentProps.booking.id,
                folio_transaction: this.folioCheckbox,
                status: "charge_now",
                credit_card: this.credit_card,
                gateway_transaction_method: "online",
              };
            }
            if (this.transaction_type == "deposit") {
              BookingService.bookingSDPayment(
                this.currentProps.booking.id,
                this.payment_id,
                paymentStatusDataArr
              )
                .then(async (response) => {
                  if (
                    response.last_payment_error_message != null &&
                    response.last_payment_error_message != ""
                  ) {
                    Swal.fire({
                      title: "Oppps !",
                      text: response.last_payment_error_message,
                      icon: "error",
                      showCancelButton: false,
                      confirmButtonColor: "#238dfa",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Ok",
                    });
                  }
                  await this.getBookingWisePayments();
                  if (this.payment_status == "authorized") {
                    this.$refs["authorized-modal"].hide();
                  } else if (this.payment_status == "mark_as_paid") {
                    this.$refs["comment-modal"].hide();
                  } else if (this.payment_status == "refunded") {
                    this.$refs["refund-modal"].hide();
                  } else if (this.payment_status == "charge_now") {
                    this.$refs["charge-modal"].hide();
                  }
                  this.is_btn_loading = false;
                  this.comment = "";
                  this.resetPaymentListModal();
                })
                .catch((error) => {
                  errorHandler(error);
                });
            } else {
              BookingService.bookingPaymentAuthNow(
                this.currentProps.booking.id,
                paymentStatusData
              )
                .then(async (response) => {
                  let tempArr = this.paymentSchedule.map((item) => {
                    if (item.id === response.id) {
                      item = response;
                    }
                    return item;
                  });
                  if (
                    response.last_payment_error_message != null &&
                    response.last_payment_error_message != ""
                  ) {
                    Swal.fire({
                      title: "Opp's !",
                      text: response.last_payment_error_message,
                      icon: "error",
                      showCancelButton: false,
                      confirmButtonColor: "#238dfa",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Ok",
                    });
                  }

                  await this.getBookingWisePayments();
                  if (this.payment_status == "authorized") {
                    this.$refs["authorized-modal"].hide();
                  } else if (this.payment_status == "mark_as_paid") {
                    this.$refs["comment-modal"].hide();
                  } else if (this.payment_status == "refunded") {
                    this.$refs["refund-modal"].hide();
                  } else if (this.payment_status == "charge_now") {
                    this.$refs["charge-modal"].hide();
                  }
                  this.is_btn_loading = false;
                  this.comment = "";
                  this.resetPaymentListModal();
                })
                .catch((error) => {
                  errorHandler(error);

                  this.commentMsg =
                    "Error Code : " +
                    error.response.data.gateway_response.gateway_error_code +
                    "<br>" +
                    "Error Message : " +
                    error.response.data.gateway_response.gateway_error_message;
                });
            }
          } else {
            this.is_btn_loading = false;
          }
        })
        .catch((error) => {
          this.is_btn_loading = false;
          errorHandler(error);
        });
    },
    // Settled total payment in booking
    transactionSettle() {
      this.is_btn_loading = true;
      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm to Make Payment",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
      })
        .then((result) => {
          if (result.value) {
            let data = {};
            if (this.select_payment_type == "mark_as_paid") {
              data = {
                booking: this.currentProps.booking.id,
                folio_transaction: this.folioCheckbox,
                status: "mark_as_paid",
                payment_method: this.payment_account,
                payment_account: this.payment_child_account,
                gateway_transaction_method: "online",
              };
            } else if (this.select_payment_type == "authorized") {
              data = {
                booking: this.currentProps.booking.id,
                folio_transaction: this.folioCheckbox,
                status: "authorized",
                credit_card: this.credit_card,
                gateway_transaction_method: "online",
              };
            } else {
              data = {
                booking: this.currentProps.booking.id,
                folio_transaction: this.folioCheckbox,
                status: "charge_now",
                credit_card: this.credit_card,
                gateway_transaction_method: "online",
              };
            }
            BookingService.transactionSettle(this.currentProps.booking.id, data)
              .then(async (response) => {
                await this.getBookingWisePayments();
                this.$refs["settle-modal"].hide();
                this.is_btn_loading = false;
                this.comment = "";
              })
              .catch((error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              });
            this.resetPaymentListModal();
          } else {
            this.is_btn_loading = false;
          }
        })
        .catch((error) => {
          this.is_btn_loading = false;
          errorHandler(error);
        });
      // }
    },
    paymentType() {
      this.paymentScheduleDropdown = "";
      let paidArray = [];
      let chargeArray = [];
      this.SDArray = [];
      BookingService.getBookingWisePayments(this.currentProps.booking.id)
        .then((response) => {
          response.map((item) => {
            if (
              item.transaction_type == "charge" &&
              item.status == "authorized"
            ) {
              let temp = {
                description: item.description,
                amount: item.debit,
                id: item.id,
                status: item.status,
              };
              paidArray.push(temp);
            }

            if (
              item.transaction_type == "charge" &&
              ((item.status != "paid" &&
                item.status != "authorized" &&
                item.status != "partial_refund" &&
                item.status != "full_refund") ||
                item.status == "pending" ||
                item.status == "overdue" ||
                item.status == "declined" ||
                item.status == "waiting_for_approval")
            ) {
              let temp = {
                description: item.description,
                amount: item.debit,
                id: item.id,
                status: item.status,
              };
              chargeArray.push(temp);
            }

            if (
              item.transaction_type == "charge" &&
              ((item.status != "paid" &&
                item.status != "authorized" &&
                item.status != "partial_refund" &&
                item.status != "full_refund") ||
                item.status == "pending" ||
                item.status == "overdue" ||
                item.status == "declined" ||
                item.status == "waiting_for_approval")
            ) {
              let temp = {
                description: item.description,
                amount: item.debit,
                id: item.id,
                status: item.status,
              };
              this.SDArray.push(temp);
            }
          });
          if (this.select_payment_type == "capture") {
            this.paymentScheduleDropdown = paidArray;
          } else if (
            this.select_payment_type == "mark_as_paid" ||
            this.select_payment_type == "authorized" ||
            this.select_payment_type == "charge_now"
          ) {
            this.paymentScheduleDropdown = chargeArray;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Open folio drawer for view folio
    openFolioDrawer() {
      this.isFolioShow = !this.isFolioShow;
    },
    SDUse() {
      this.is_btn_loading = true;

      if (
        this.sd_charges.total_selected_charges > this.sd_charges.total_sd ||
        this.sd_charges.total_selected_charges == 0
      ) {
        this.is_btn_loading = false;
        this.sd_charges.error_msg =
          "Charges is greater than Security Deposit balance";
        return;
      }

      Swal.fire({
        title: "Are you Sure?",
        text: "Confirm to Use",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.value) {
          let data = {};
          data = {
            booking: this.currentProps.booking.id,
            folio_transaction: this.SdFolioCheckbox,
            status: "capture",
          };
          BookingService.bookingSDPayment(
            this.currentProps.booking.id,
            this.payment_id,
            data
          )
            .then(async (response) => {
              await this.getBookingWisePayments();
              this.$refs["use-top-pay-modal"].hide();
              this.is_btn_loading = false;
              this.comment = "";
            })
            .catch((error) => {
              this.is_btn_loading = false;
              errorHandler(error);
            });
          this.resetPaymentListModal();
        } else {
          this.is_btn_loading = false;
        }
      });
    },
    selectCharge(amt, id) {
      if (this.folioCheckbox.includes(id)) {
        // this.sd_charges.total_selected_charges
        this.total_selected_charges =
          parseFloat(this.total_selected_charges) + parseFloat(amt);
      } else {
        this.total_selected_charges =
          parseFloat(this.total_selected_charges) - parseFloat(amt);
      }
      this.total_selected_charges = this.total_selected_charges.toFixed(2);
    },
    selectSDCharge(amt, id) {
      if (this.SdFolioCheckbox.includes(id)) {
        // this.sd_charges.total_selected_charges
        this.sd_charges.total_selected_charges =
          parseFloat(this.sd_charges.total_selected_charges) + parseFloat(amt);
      } else {
        this.sd_charges.total_selected_charges =
          parseFloat(this.sd_charges.total_selected_charges) - parseFloat(amt);
      }
      this.sd_charges.total_selected_charges =
        this.sd_charges.total_selected_charges.toFixed(2);
      if (this.sd_charges.total_selected_charges > this.sd_charges.total_sd) {
        this.sd_charges.error_msg =
          "Charges is greater than Security Deposit balance";
      } else {
        this.sd_charges.error_msg = "";
      }
    },
    makePayment() {
      this.is_data_loading = false;
      this.$refs["settle-modal"].show();
    },
    async chargeType() {
      const chargesResponse = await UserService.getChargesTypeList();
      if (chargesResponse !== undefined) {
        this.charge_type_list = [];
        chargesResponse.map((item) => {
          this.charge_type_list.push({
            value: item.id,
            text: item.name,
          });
        });
      }
    },
  },
};
</script>

<template>
  <b-tab>
    <template v-slot:title>
      <span class="d-inline-block d-sm-none">
        <i class="fas fa-home"></i>
      </span>
      <span class="d-none d-sm-inline-block">Payments</span>
    </template>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div>
                <span class="me-3"
                  >Charges: $ {{ currentProps.booking.total_charge }}
                </span>
                <span class="me-3"
                  >Payments: $ {{ currentProps.booking.total_payment }}</span
                >
                <span class="me-3"
                  >Refunds: $ {{ currentProps.booking.total_refund }}</span
                >
                <span class="me-3"
                  >Current Balance : $
                  {{ currentProps.booking.current_balance }}</span
                >
                <span class="me-3"
                  >Security Deposit(I Hold):
                  <strong class="text-danger"
                    >$
                    {{ currentProps.booking.security_deposit_on_hold }}</strong
                  ></span
                >
                <a href="#" class="btn btn-primary btn-sm" @click="makePayment"
                  >Make Payment</a
                >
              </div>

              <a
                class="float-end btn btn-primary btn-sm"
                href="#"
                @click="openFolioDrawer"
                >View Folio</a
              >
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div
            class="col-md-4"
            v-for="(schedule, index) in paymentSchedule"
            :key="index"
          >
            <div
              class="card bg-lightgray border-0 rounded-top"
              v-if="!is_data_loading"
            >
              <div class="card-body payment-card-body">
                <div class="row">
                  <div class="col-md-12">
                    <h3
                      class="card-title float-start text-overflow text-truncate"
                    >
                      {{ schedule.description }}
                    </h3>

                    <b-dropdown
                      class="float-end text-dark"
                      v-if="Object.keys(schedule.options).length > 0"
                      size="sm"
                      variant="white"
                      right
                      toggle-class="p-0"
                      menu-class="dropdown-menu-end"
                    >
                      <template #button-content>
                        <i class="fas fa-ellipsis-v text-dark"></i>
                      </template>
                      <b-dropdown-item
                        href="#"
                        v-for="(option, option_index) in schedule.options"
                        :key="option_index"
                        @click="
                          paymentStatusChange(
                            schedule.id,
                            option_index,
                            schedule.amount,
                            schedule.amount_received,
                            schedule.amount_authorized,
                            schedule.amount_refunded,
                            schedule.amount_released,
                            schedule.payment_method_id,
                            schedule.payment_account_id,
                            schedule.payment_method,
                            schedule.payment_type
                          )
                        "
                      >
                        {{ option }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4">
                    <h3 class="card-title">
                      $ {{ schedule.amount }}
                      <i
                        class="fas fa-info-circle"
                        v-b-popover.hover.bottom="
                          getDiffAmount(
                            schedule.amount_authorized,
                            schedule.amount_received,
                            schedule.amount_refunded,
                            schedule.amount_released,
                            schedule.transaction_type
                          )
                        "
                      ></i>
                    </h3>
                  </div>
                  <div
                    class="col-md-8 text-danger"
                    v-if="schedule.last_payment_error_code"
                  >
                    <span class="d-block error-text font-size-10"
                      >Error Code: {{ schedule.last_payment_error_code }}</span
                    >
                    <span class="d-block error-text font-size-10"
                      >Error Msg:
                      {{ schedule.last_payment_error_message }}</span
                    >
                  </div>
                  <div class="col-md-12">
                    <span class="font-size-11"
                      >Balance: $
                      {{
                        findBalance(schedule.amount, schedule.amount_received)
                      }}</span
                    >
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-12 bg-gradient mt-3 py-1"
                    :class="schedule.bg_class"
                  >
                    <div class="payment-date p-0 m-0">
                      <p class="float-start">
                        <i :class="schedule.icon"></i>
                        {{ schedule.payment_status }}

                        <span v-if="schedule.payment_account_id != null">
                          {{ schedule.payment_account_id.name }}
                          {{
                            schedule.payment_method == null ||
                            schedule.payment_method == ""
                              ? ""
                              : "- " + schedule.payment_method.last_digit
                          }}
                        </span>
                        <span v-else>
                          {{ schedule.payment_method }}
                          {{
                            schedule.payment_method == null ||
                            schedule.payment_method == ""
                              ? ""
                              : "- " + schedule.payment_method.last_digit
                          }}
                        </span>
                      </p>

                      <span
                        v-if="schedule.payment_schedule"
                        class="text-white float-end font-size-11"
                      >
                        {{ schedule.payment_schedule }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- For loader in payment schedule start -->
            <div
              class="card"
              :class="schedule.border_class"
              v-if="is_data_loading"
            >
              <div class="card-body payment-card-body">
                <div class="col-md-12">
                  <div class="placeholder-glow">
                    <div
                      class="placeholder w-100 placeholder-lg m-0 mb-2"
                    ></div>
                  </div>

                  <div class="placeholder-glow">
                    <div
                      class="placeholder w-100 placeholder-lg m-0 mb-2"
                    ></div>
                  </div>
                </div>
                <div class="mt-3 placeholder-glow">
                  <div class="placeholder w-100 placeholder-lg m-0"></div>
                </div>
              </div>
            </div>
            <!-- end loader in payment schedule -->
          </div>
          <!-- Section is for open additional charge model -->
          <div class="col-md-4">
            <div
              class="card payment-box"
              data-bs-toggle="modal"
              @click="openAdditionalChargeModel = true"
              v-b-modal.addtional-charge-modal
            >
              <div
                class="card-body d-flex align-items-center justify-content-center"
              >
                <i class="fas fa-plus fs-3"></i>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <!-- Section is for add new card and display cards -->
        <div class="row">
          <h4>Card On File</h4>
        </div>
        <div class="row">
          <div class="col-md-4" v-for="card in cardList" :key="card.id">
            <div class="card">
              <div class="card-body bg-lightgray">
                <div class="row">
                  <div class="col-md-12">
                    <div class="d-flex justify-content-between">
                      <div>
                        <i
                          class="mdi mdi-spin mdi-loading fs-5"
                          v-if="is_card_loading"
                        ></i>
                        <i
                          class="far fas fa-check-circle text-success fs-5"
                          v-if="
                            card.id ===
                              currentProps.booking.default_credit_card &&
                            !is_card_loading
                          "
                          @click="defaultPaymentMethod(card.id)"
                        ></i>
                        <i
                          class="far fa-check-circle fs-5"
                          v-if="
                            card.id !=
                              currentProps.booking.default_credit_card &&
                            !is_card_loading
                          "
                          @click="defaultPaymentMethod(card.id)"
                        ></i>
                      </div>
                      <div v-if="card.card_brand === 'visa'" :key="card.id">
                        <img
                          class="img-fluid"
                          src="@/assets/images/visa.png"
                          alt="visa card"
                        />
                      </div>
                      <div
                        v-else-if="card.card_brand === 'dcvr'"
                        :key="card.id + 1"
                      >
                        <i class="fab fa-cc-visa text-dark w-30"></i>
                      </div>
                      <div
                        v-else-if="card.card_brand === 'amex'"
                        :key="card.id + 2"
                      >
                        <i class="fab fa-cc-visa text-dark w-30"></i>
                      </div>
                      <div
                        v-else-if="card.card_brand === 'dclb'"
                        :key="card.id + 3"
                      >
                        <i class="fab fa-cc-visa text-dark w-30"></i>
                      </div>
                      <div
                        v-else-if="card.card_brand === 'm/c'"
                        :key="card.id + 4"
                      >
                        <img
                          class="img-fluid w-75 float-end"
                          src="@/assets/images/brands/master.png"
                          alt="master"
                        />
                      </div>
                      <div
                        v-else-if="card.card_brand === 'jcb'"
                        :key="card.id + 6"
                      >
                        <img
                          class="img-fluid w-30"
                          src="@/assets/images/brands/jcb.png"
                          alt="master"
                        />
                      </div>
                      <div v-else :key="card.id + 5">
                        <img
                          class="img-fluid w-30"
                          src="@/assets/images/brands/other.png"
                          alt="master"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-12 mt-1 text-dark font-weight-semibold text-center"
                    style="letter-spacing: 3px"
                  >
                    {{ "XXXX XXXX XXXX " + card.last_digit }}
                  </div>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mt-2"
                  :class="card.card_type === 'emv' ? '' : 'mt-3'"
                >
                  <span class="font-weight-semibold text-dark">{{
                    card.card_holder_name !== null
                      ? card.card_holder_name
                      : primaryGuestAsCardHolderName
                  }}</span>
                  <img
                    v-if="card.card_type === 'emv'"
                    src="@/assets/images/chip.png"
                    alt="emv chip"
                    class="img-fluid"
                  />
                  <span v-else>{{ card.exp_month }}/{{ card.exp_year }}</span>
                </div>
              </div>
            </div>
            <div class="row d-none">
              <div class="card plan-box custome-card-height payment-card-box">
                <div class="row p-2">
                  <div class="col-1"></div>
                  <div class="col-10">
                    <div
                      class="justify-content-between d-flex align-items-center"
                    >
                      <span class="text-dark"
                        >{{ card.card_holder_name }}
                      </span>
                    </div>
                    <div class="card-infos mt-1">
                      <span>
                        <i
                          class="fab fa-cc-visa text-dark fa-1x me-1"
                          v-if="card.card_brand === 'visa'"
                        ></i>
                        <i
                          class="fab fa-cc-mastercard text-dark fa-1x me-1"
                          v-else
                        ></i>
                      </span>
                      <span class="text-dark me-2"
                        >** {{ card.last_digit }}</span
                      >
                      <span
                        class="ml-auto text-dark"
                        v-if="card.exp_month != null || card.exp_month != ''"
                        >Exp. {{ card.exp_month }}/{{ card.exp_year }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div
              class="card plan-box custome-card-height payment-card-box"
              v-b-modal.add-payment-method
              @click="add_new_card = true"
            >
              <div
                class="card-body p-1 d-flex align-items-center justify-content-center"
              >
                <a href="javascript: void(0);" ref="submitBtn">
                  <i class="fas fa-plus fs-3 text-secondary"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <!-- Section is for cancelation policy -->
        <div class="row">
          <div class="col-md-12">
            <div class="d-inline-flex">
              <i class="bx bx-send fs-2 text-primary me-2"></i>
              <h3 class="font-size-20">Cancellation Policy</h3>
            </div>
            <div class="ps-4 ms-3" v-if="cancellationPolicy">
              <h5>
                Guest won't be charged with fees if they cancel booking within
                {{
                  cancellation_fee_within
                    .find(
                      (item) =>
                        item.value == cancellationPolicy.when_to_full_refund
                    )
                    .text.replace("More than", "")
                }}
                And full refund will be provided
                {{
                  when_booking.find(
                    (item) => item.value == cancellationPolicy.when_full_refund
                  ).text
                }}.
              </h5>
              <ul>
                <li
                  v-for="item in cancellationPolicy.cancellation_policy_charge"
                  :key="item.id"
                >
                  Cancelled Within
                  {{
                    cancellation_fee_within
                      .find((x) => x.value == item.cancelled_within)
                      .text.replace("More than", "")
                  }}
                  ---> {{ item.cancellation_fee }} % of total amount charge with
                  {{ item.flat_fee }} flat fee.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-if="openAdditionalChargeModel"
      id="addtional-charge-modal"
      centered
      title="Add Additional Charge"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
      @close="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-2">
              <b-form-group label="amount" label-for="name-input">
                <p slot="label" class="mb-2">
                  Amount <span class="text-danger">*</span>
                </p>
                <b-form-input
                  id="name-input"
                  placeholder="Amount Like : $10.00"
                  type="number"
                  autocomplete="off"
                  step="0.01"
                  v-model="additionalCharge.amount"
                  :class="{
                    'is-invalid':
                      (additionalCharge.submitted &&
                        $v.additionalCharge.amount.$error) ||
                      (additionalCharge.submitted &&
                        additionalCharge.createError),
                  }"
                ></b-form-input>
                <div v-if="additionalCharge.submitted" class="invalid-feedback">
                  <span v-if="!$v.additionalCharge.amount.required"
                    >Amount is required.</span
                  >
                  <span v-if="additionalCharge.createError">{{
                    additionalCharge.errorMessage
                  }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="mb-2">
              <b-form-group label="description" label-for="name-input">
                <p slot="label" class="mb-2">
                  Description <span class="text-danger">*</span>
                </p>
                <b-form-input
                  id="name-areb-form-input"
                  placeholder="Description"
                  type="text"
                  autocomplete="off"
                  v-model="additionalCharge.description"
                  :class="{
                    'is-invalid':
                      (additionalCharge.submitted &&
                        $v.additionalCharge.description.$error) ||
                      (additionalCharge.submitted &&
                        additionalCharge.createError),
                  }"
                ></b-form-input>
                <div v-if="additionalCharge.submitted" class="invalid-feedback">
                  <span v-if="!$v.additionalCharge.description.required"
                    >Description is required.</span
                  >
                  <span v-if="additionalCharge.createError">{{
                    additionalCharge.errorMessage
                  }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="mb-2">
              <b-form-group
                class="mb-3 form-label"
                label="Charge Type"
                label-for="card-input"
              >
                <p slot="label">
                  Select Charge Type <span class="text-danger">*</span>
                </p>

                <b-form-select
                  class="form-select"
                  id="card-input"
                  type="text"
                  autocomplete="off"
                  placeholder="Select charge type"
                  :options="charge_type_list"
                  v-model="additionalCharge.charge_type"
                >
                </b-form-select>
                <div v-if="additionalCharge.submitted" class="invalid-feedback">
                  <span v-if="!$v.additionalCharge.charge_type.required"
                    >Charge Type is required.</span
                  >
                  <span v-if="additionalCharge.createError">{{
                    additionalCharge.errorMessage
                  }}</span>
                </div>
              </b-form-group>
            </div>
            <div>
              <button
                class="btn btn-primary float-end mt-3"
                @click="handleOk"
                :class="{ disabled: isBtnLoading }"
              >
                <i
                  v-if="isBtnLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                ></i>
                Add Additional Charge
              </button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Add Payment Method Model -->
    <b-modal
      v-if="add_new_card"
      id="add-payment-method"
      centered
      title="Add New Card"
      hide-footer
      title-class="font-18"
      @hidden="resetPaymentModal"
      @close="resetPaymentModal"
    >
      <b-card-body>
        <b-card-text>
          <form ref="form">
            <b-card no-body class="shadow-none">
              <b-card-body>
                <b-card-text>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-12">
                          <b-form-group>
                            <div class="d-flex align-items-center">
                              <b-form-radio
                                v-model="card_type"
                                class="mb-3 w-50"
                                value="online"
                                plain
                                >Online-CC
                              </b-form-radio>

                              <b-form-radio
                                v-model="card_type"
                                class="form-check mb-3 w-50"
                                value="emv"
                                plain
                                >EMV-CC
                              </b-form-radio>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row" v-if="card_type == 'emv'">
                        <div class="col-12">
                          <b-form-group
                            class="mb-3 form-label"
                            label="Kiosk Policy Select"
                            label-for="card-input"
                          >
                            <p slot="label">
                              Kiosk Machine Select
                              <span class="text-danger">*</span>
                            </p>

                            <b-form-select
                              class="form-select"
                              id="card-input"
                              type="text"
                              autocomplete="off"
                              placeholder="Select kiosk policy"
                              :options="getKioskPolicyList"
                              v-model="kiosk"
                            >
                            </b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="row" v-if="card_type == 'online'">
                        <div class="col-md-12">
                          <div class="form-group">
                            <b-form-input
                              id="first-last-input"
                              type="text"
                              autocomplete="off"
                              placeholder="Card holder name"
                              v-model="cardHolder"
                            ></b-form-input>
                          </div>
                          <div v-if="cardErrors.cardHolder" class="error">
                            <small>{{ cardErrors.cardHolder }}</small>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2" v-if="card_type == 'online'">
                        <div class="col-md-12">
                          <div class="form-group">
                            <b-form-input
                              ref="cardNumInput"
                              id="first-last-input"
                              v-cardformat:formatCardNumber
                              placeholder="XXXX XXXX XXXX XXXX"
                              v-model="cardNumber"
                              :data-error="cardErrors.cardNumber ? true : false"
                              @change="
                                () => {
                                  isError = false;
                                  is_btn_loading = false;
                                }
                              "
                            ></b-form-input>
                          </div>
                          <div v-if="cardErrors.cardNumber" class="error">
                            <small>{{ cardErrors.cardNumber }}</small>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2" v-if="card_type == 'online'">
                        <div class="col-md-6">
                          <div class="form-group">
                            <b-form-input
                              ref="cardExpInput"
                              id="first-last-input"
                              v-cardformat:formatCardExpiry
                              placeholder="MM / YYYY"
                              v-model="cardExpiry"
                              :data-error="cardErrors.cardExpiry ? true : false"
                            ></b-form-input>
                          </div>
                          <div v-if="cardErrors.cardExpiry" class="error">
                            <small>{{ cardErrors.cardExpiry }}</small>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <b-form-input
                              ref="cardCvcInput"
                              id="first-last-input"
                              v-cardformat:formatCardCVC
                              placeholder="CVV"
                              v-model="cardCvv"
                              :data-error="cardErrors.cardCvv ? true : false"
                            >
                            </b-form-input>
                          </div>
                          <div v-if="cardErrors.cardCvv" class="error">
                            <small>{{ cardErrors.cardCvv }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-card>
            <div v-if="isError">
              <b-alert v-if="isError" show variant="danger">
                <p v-html="cardErrorMessage"></p>
              </b-alert>
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  v-if="card_type == 'online'"
                  class="btn btn-primary float-end"
                  type="button"
                  @click="addNewCard"
                  :class="{ disabled: is_btn_loading }"
                >
                  <i
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    v-if="is_btn_loading"
                  ></i>
                  Add New Card
                </button>
                <button
                  v-if="card_type == 'emv'"
                  class="btn btn-primary float-end"
                  type="button"
                  @click="emvCardAdd"
                  :class="{ disabled: is_btn_loading }"
                >
                  <i
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    v-if="is_btn_loading"
                  ></i>
                  Add New Card
                </button>
              </div>
            </div>
          </form>
        </b-card-text>
      </b-card-body>
    </b-modal>

    <!-- capture payment amount -->
    <b-modal
      id="capture"
      ref="capture-modal"
      centered
      title="Capture Amount"
      hide-footer
      title-class="font-18"
    >
      <div class="row">
        <div class="col-md-12 mb-3">
          <label for="payment_capture_amount"
            >Amount <span class="text-danger">*</span></label
          >
          <input
            type="number"
            autocomplete="off"
            class="form-control"
            step="0.01"
            :min="capture_min"
            :max="capture_max"
            v-model="capture_amount"
            @keyup="captureValCheck"
            required
          />
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">Select Method <span class="text-danger">*</span></p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_account_list"
              v-model="payment_account"
              @change="getPaymentChildAccountDrop(payment_account, 'single')"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Account <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_child_account_list"
              v-model="payment_child_account"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Method <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="paymentMethods"
              v-model="credit_card"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="remark">Remarks</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            v-model="comment"
            placeholder="Type here........."
            name="remark"
          />
        </div>
      </div>
      <div v-if="isError">
        <p class="text-danger">{{ captureAmountMsg }}</p>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button
            class="btn btn-primary"
            type="button"
            @click="capturePayment"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Capture
          </button>
        </div>
      </div>
    </b-modal>

    <!-- booking payment comment  -->
    <b-modal
      id="comment"
      ref="comment-modal"
      centered
      title="Payment Status Change"
      hide-footer
      title-class="font-18"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="mb-2">
            <label for="Select payment method"
              >Select payment method <span class="text-danger">*</span></label
            >
            <multiselect
              :options="payment_account_list"
              v-model="payment_account"
              track-by="value"
              label="text"
              :show-labels="false"
              placeholder="Select payment method"
              @close="getPaymentChildAccountDrop(payment_account, 'multi')"
            >
            </multiselect>
          </div>
          <div class="mb-2">
            <label slot="label">
              Select Payment Account <span class="text-danger">*</span>
            </label>
            <multiselect
              :options="payment_child_account_list"
              v-model="payment_child_account"
              track-by="value"
              label="text"
              :show-labels="false"
              placeholder="Select payment account"
            >
            </multiselect>
          </div>
          <div class="mb-2">
            <label for="comment">Remark</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              v-model="comment"
              placeholder="Type here........."
              name="remark"
            />
          </div>
        </div>
        <div class="mt-2" v-if="commentError">
          <b-alert v-if="commentMsg !== ''" show variant="danger">
            <p v-html="commentMsg"></p>
          </b-alert>
        </div>
        <div class="col-md-12 mt-2">
          <button
            class="btn btn-primary"
            type="button"
            @click="bookingPaymentAuthNow"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Charge now modal for payment -->
    <b-modal
      id="charge"
      ref="charge-modal"
      centered
      title="Payment Status Change"
      hide-footer
      title-class="font-18"
    >
      <div class="row">
        <div class="col-md-12 d-none">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Method <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="id"
              placeholder="Select payment method"
              :options="payment_account_list"
              v-model="payment_account"
              @change="getPaymentChildAccountDrop(payment_account, 'single')"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-none">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Account <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_child_account_list"
              v-model="payment_child_account"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Method <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="paymentMethods"
              v-model="credit_card"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="remark">Remark</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            v-model="comment"
            placeholder="Type here........."
            name="remark"
          />
        </div>
      </div>
      <div class="mt-2" v-if="commentError">
        <b-alert v-if="commentMsg !== ''" show variant="danger">
          <p v-html="commentMsg"></p>
        </b-alert>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button
            class="btn btn-primary"
            type="button"
            @click="bookingPaymentAuthNow"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Payment authorization modal -->
    <b-modal
      id="authorized"
      ref="authorized-modal"
      centered
      title="Payment Status Change"
      hide-footer
      title-class="font-18"
    >
      <div class="row d-none">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Account <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_account_list"
              v-model="payment_account"
              @change="getPaymentChildAccountDrop(payment_account, 'single')"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Child Account <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_child_account_list"
              v-model="payment_child_account"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Method <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="paymentMethods"
              v-model="credit_card"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <label for="remark">Remark</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            v-model="comment"
            placeholder="Type here........."
            name="remark"
          />
        </div>
      </div>
      <div class="mt-2" v-if="commentError">
        <b-alert v-if="commentMsg !== ''" show variant="danger">
          <p v-html="commentMsg"></p>
        </b-alert>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button
            class="btn btn-primary"
            type="button"
            @click="bookingPaymentAuthNow"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="refund"
      ref="refund-modal"
      centered
      title="Refund Amount"
      hide-footer
      title-class="font-18"
    >
      <div class="row">
        <div class="col-md-12 mb-3">
          <label for="payment_capture_amount"
            >Amount <span class="text-danger">*</span></label
          >
          <input
            type="number"
            autocomplete="off"
            class="form-control"
            step=".01"
            :min="refund_min"
            :max="refund_max"
            v-model="refund_amount"
            @keyup="refundValCheck"
            readonly
            required
          />
          <!-- @keyup="refundValCheck" -->
        </div>
      </div>
      <div class="row" v-if="payment_account">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">Select Method <span class="text-danger">*</span></p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_account_list"
              v-model="payment_account"
              @change="getPaymentChildAccountDrop(payment_account, 'single')"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row" v-if="payment_child_account">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Account <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="payment_child_account_list"
              v-model="payment_child_account"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row d-none">
        <div class="col-md-12">
          <b-form-group
            class="mb-3 form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label">
              Select Payment Method <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="paymentMethods"
              v-model="credit_card"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="remark">Remarks</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            v-model="comment"
            placeholder="Type here........."
            name="remark"
          />
        </div>
      </div>
      <div v-if="isError">
        <p class="text-danger">{{ refundAmountMsg }}</p>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button
            class="btn btn-primary"
            type="button"
            @click="bookingPaymentAuthNow"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Payment for multiple payment balance settlement model -->
    <b-modal
      id="settle"
      ref="settle-modal"
      centered
      size="lg"
      title="Make Payment"
      hide-footer
      title-class="font-18"
    >
      <div class="row mb-3">
        <div class="co-md-12">
          <span class="me-3" v-if="total_selected_charges > 8">
            <span class="text-danger"
              >Amount is more then a Merchant capacity.</span
            >
          </span>
          <span class="me-3" v-else>
            Total Selected Charges:
            <strong class="text-danger"
              >$ {{ total_selected_charges }}</strong
            ></span
          >
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="select_payment_type">Select Payment mode</label>
          <select
            name="select_payment_type"
            class="form-control text-dark"
            id="select_payment_type"
            @change="paymentType"
            v-model="select_payment_type"
          >
            <option value="charge_now">Charge now</option>
            <option value="authorized">Authorize now</option>
            <option value="capture" selected>Capture now</option>
            <option value="mark_as_paid">Mark as paid</option>
          </select>
        </div>
        <div
          class="col-md-6 mb-3"
          v-if="
            select_payment_type == 'authorized' ||
            select_payment_type == 'charge_now'
          "
        >
          <b-form-group
            class="form-label"
            label="Payment Method"
            label-for="card-input"
          >
            <p slot="label" class="p-0 m-0">
              Select Payment Method <span class="text-danger">*</span>
            </p>

            <b-form-select
              class="form-select"
              id="card-input"
              type="text"
              autocomplete="off"
              placeholder="Select payment method"
              :options="paymentMethods"
              v-model="credit_card"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <div v-if="select_payment_type == 'mark_as_paid'">
        <div class="row">
          <div class="col-md-6">
            <b-form-group
              class="mb-3 form-label"
              label="Payment Method"
              label-for="card-input"
            >
              <p slot="label">
                Select Payment Method <span class="text-danger">*</span>
              </p>

              <b-form-select
                class="form-select"
                id="card-input"
                type="text"
                autocomplete="off"
                placeholder="Select payment method"
                :options="payment_account_list"
                v-model="payment_account"
                @change="getPaymentChildAccountDrop(payment_account, 'single')"
              >
              </b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              class="mb-3 form-label"
              label="Payment Method"
              label-for="card-input"
            >
              <p slot="label">
                Select Payment Account <span class="text-danger">*</span>
              </p>

              <b-form-select
                class="form-select"
                id="card-input"
                type="text"
                autocomplete="off"
                placeholder="Select payment account"
                :options="payment_child_account_list"
                v-model="payment_child_account"
              >
              </b-form-select>
            </b-form-group>
          </div>
        </div>
      </div>

      <label class="mt-2" v-if="paymentScheduleDropdown.length > 0"
        >Payment Summary</label
      >
      <div class="mb-3">
        <div
          class="row"
          v-for="(paymentDropdown, index) in paymentScheduleDropdown"
          :key="index"
        >
          <div class="col-md-4">
            <p class="mb-0">{{ paymentDropdown.description }}</p>
          </div>
          <div class="col-md-4">
            <p class="mb-0">
              <b>$ {{ paymentDropdown.amount }}</b>
            </p>
          </div>
          <div class="col-md-3 text-dark">
            <p class="mb-0">
              <b>{{ paymentDropdown.status }}</b>
            </p>
          </div>
          <div class="col-md-1 text-end">
            <span>
              <input
                class="cursor"
                type="checkbox"
                :id="index"
                :value="paymentDropdown.id"
                v-model="folioCheckbox"
                @change="
                  selectCharge(paymentDropdown.amount, paymentDropdown.id)
                "
              />
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label for="remark">Remarks</label>
          <input
            type="text"
            autocomplete="off"
            class="form-control"
            v-model="comment"
            placeholder="Type here..."
            name="remark"
          />
        </div>
      </div>
      <div v-if="isError">
        <p class="text-danger">{{ refundAmountMsg }}</p>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button
            class="btn btn-primary"
            type="button"
            @click="transactionSettle"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="use-top-pay"
      ref="use-top-pay-modal"
      centered
      size="lg"
      title="Use to pay"
      hide-footer
      title-class="font-18"
    >
      <div class="row mb-2">
        <div class="co-md-12">
          <span class="me-3"
            >Authorize : $ {{ sd_charges.authorize_amount }}
          </span>
          <span class="me-3">Receive : $ {{ sd_charges.received_amount }}</span>
          <span class="me-3">Release : $ {{ sd_charges.release_amount }}</span>
          <span class="me-3"
            >Total:
            <strong class="text-danger"
              >$ {{ sd_charges.total_sd }}</strong
            ></span
          >
          <span class="me-3">|</span>
          <span class="me-3"
            >Total Selected Charges:
            <strong class="text-danger"
              >$ {{ sd_charges.total_selected_charges }}</strong
            ></span
          >
        </div>
      </div>

      <label class="mt-2" v-if="SDArray.length > 0">Payment Summary</label>
      <div
        class="row mb-1"
        v-for="(paymentDropdown, index) in SDArray"
        :key="index"
      >
        <div class="col-md-6">
          <p>{{ paymentDropdown.description }}</p>
        </div>
        <div class="col-md-5">
          <b>$ {{ paymentDropdown.amount }}</b>
        </div>
        <div class="col-md-1 text-end">
          <span>
            <input
              type="checkbox"
              :id="paymentDropdown.id"
              :value="paymentDropdown.id"
              v-model="SdFolioCheckbox"
              @change="
                selectSDCharge(paymentDropdown.amount, paymentDropdown.id)
              "
            />
          </span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <button
            class="btn btn-primary"
            type="button"
            @click="SDUse"
            :class="{ disabled: is_btn_loading }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="is_btn_loading"
            ></i>
            Submit
          </button>
        </div>
        <div class="col-md-8" v-if="sd_charges.error_msg != ''">
          <p class="text-danger">{{ sd_charges.error_msg }}</p>
        </div>
      </div>
    </b-modal>

    <!-- Model is for open folio -->
    <Drawer
      @close="openFolioDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1040"
      class="w-100"
    >
      <div v-if="isFolioShow">
        <Folio
          :currentProps="{
            booking: currentProps.booking,
            detailProps: detailProps,
            total_charges: currentProps.booking.total_charge,
            total_payment: currentProps.booking.total_payment,
            current_bal: currentProps.booking.current_balance,
            total_sd: currentProps.booking.security_deposit_on_hold,
          }"
        />
      </div>
    </Drawer>
  </b-tab>
</template>

<style scoped>
.bg-lightgray {
  background: #f2f2f2;
}

option {
  color: red;
}

.payment-date {
  color: #000;
}

.payment-date p {
  padding: 1px 5px 1px 5px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 0px;
  font-size: 11px;
  font-weight: 500;
  box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
  color: #fff;
  position: relative;
}

.payment-date span {
  padding-left: 14px;
  letter-spacing: 0.5px;
}

.text-overflow {
  width: 90%;
}

.payment-box {
  max-height: 132px;
  height: 100%;
  border-style: dashed;
}

.payment-card-box {
  max-height: 135px;
  height: 135px;
}

.payment-card-body {
  padding: 12px 12px 0px 12px;
}

.w-30 {
  width: 30px;
}
</style>
